import React from 'react'
import CostCenterTree from '../CostCenter/CostCenterTree'

const CostCenterFilter = ({setCostCenterFilter, setCostCenterName}) => {

  const handleClickCostCenterName = costCenter => {
    setCostCenterName(costCenter.displayName)
    setCostCenterFilter(prev => (costCenter.id === prev ? '' : costCenter.id))
  }


  return (
    <CostCenterTree onClick={handleClickCostCenterName} isClickable={() => true} />
  )
}

export default CostCenterFilter
